export default __webpack_public_path__ + "static/char-s-14-kr-b98935ceab9a044f582fb8dfc1b7b267.png";